<app-modal-generico [modelo]="modalGenerico">
  <div class="p-5">
    <header class="text-center mb-3">
      <label class="h5">Lista Valor</label>
    </header>
    <form [formGroup]="formFormulaPregunta" (ngSubmit)="close()">
      <div class="form-group">
        <label class="small text-secondary" for="">Origen</label>
        <select
          class="form-control form-control-sm"
          id="origenes_lista_valor_id"
          formControlName="origenes_lista_valor_id"
          (change)="cambiarOrigen($event.target.value)"
        >
          <option [ngValue]="null" selected="true">Seleccione</option>
          <option
            *ngFor="let option of origenesValorLista; let i = index"
            [ngValue]="option?.origenes_lista_valor_id"
          >{{ option?.descripcion }}</option>
        </select>
      </div>
      <div *ngIf="hasKey" class="form-group">
        <label class="small text-secondary" for="nit">Dependencia</label>
        <select
          *ngIf="isAditional"
          class="form-control form-control-sm"
          id="pregunta_adicional_encuesta_id_dependencia"
          formControlName="pregunta_adicional_encuesta_id_dependencia"
          (change)="cambiarDependencia($event.target.value)"
        >
          <option [ngValue]="null" selected="true">Seleccione</option>
          <option
            *ngFor="let option of preguntaOrigenLista; let i = index"
            [ngValue]="option?.pregunta_encuesta_id"
          >{{ option?.descripcion }}</option>
        </select>
        <select
          *ngIf="!isAditional"
          class="form-control form-control-sm"
          id="pregunta_encuesta_id_dependencia"
          formControlName="pregunta_encuesta_id_dependencia"
          (change)="cambiarDependencia($event.target.value)"
        >
          <option [ngValue]="null" selected="true">Seleccione</option>
          <option
            *ngFor="let option of preguntaOrigenLista; let i = index"
            [ngValue]="option?.pregunta_encuesta_id"
          >{{ option?.descripcion }}</option>
        </select>
      </div>
      <div class="form-row mt-5">
        <button (click)="dismiss()" type="button" class="btn btn-outline-primary border-0 m-auto">
          cancelar
        </button>
        <button [disabled]="hasKey && !hasDepVal" class="btn btn-primary m-auto" type="submit">Guardar</button>
      </div>
    </form>
  </div>
</app-modal-generico>
